<template>
  <modal :modal-key="'pending_challenged_request_rematch'" :class-style="determineWinnerCSSClass"
         :footer-style="'footer_buttons'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_pending_chall_req_your_rematch_request }}</h1>
      <ul>
        <li>
          <img :src=homeAvatar alt="">
          <span class="name">{{ homeUsername }}</span>
        </li>
        <li class="trophy">
          <img src="static/images/trophy.png" alt="">
          <div class="score"><span>{{ challengeInfo.forRematchHomeScore }}</span>-<span>{{ challengeInfo.forRematchAwayScore }}</span></div>
        </li>
        <li>
          <img :src=awayAvatar alt="">
          <span class="name">{{ awayUsername }}</span>
        </li>
      </ul>
    </template>
    <template slot="body">
      <p></p>
      <h2 class="modal_sub">{{ getTranslations.home_pending_chall_req_hi }} {{ userDetails.username }} {{
          getTranslations.home_pending_chall_req_ready_to_play }}
      </h2>
      <div class="waiting_content">
        <p>{{ getTranslations.home_pending_chall_req_opponent_waiting }}</p>
        <div id="timer"></div>
      </div>
    </template>
    <template slot="footer">
      <a class="btn2  btn2--outline btn2--small" @click.prevent="responseToChallengeMethod(false)">{{
        getTranslations.home_pending_chall_req_decline }}</a>
      <a class="btn2 btn2--small btn2--std" @click.prevent="responseToChallengeMethod(true)">{{
        getTranslations.home_pending_chall_req_accept }}</a>
    </template>
  </modal>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import PendingTimeRematch from '@/common/jQueryMixin';

export default {
  // modal_pending_request_rematched_user
  name: 'pending-challenged-request-request',
  mixins: [
    PendingTimeRematch,
  ],
  components: {
    Modal,
  },
  data() {
    return {
      homeAvatar: null,
      homeUsername: null,
      awayAvatar: null,
      awayUsername: null,
    };
  },
  beforeDestroy() {
    this.onTimesUp();
    this.storeModalForChallenge(null);
  },
  mounted() {
    this.$nextTick(() => {
      this.initiateTimer(this.timeToAcceptChallenge / 1000, 0, false);
      // fix animation on window resize
      // eslint-disable-next-line
      // $(window).resize(() => this.initiateTimer(this.timeToAcceptChallenge / 1000, 0, false));
    });
  },
  created() {
    this.homeAvatar = this.challengeInfo.forRematchIsHome ? this.challengeInfo.challengingAvatar : this.userDetails.avatar;
    this.homeUsername = this.challengeInfo.forRematchIsHome ? this.challengeInfo.challengingUsername : this.userDetails.username;
    this.awayAvatar = this.challengeInfo.forRematchIsHome ? this.userDetails.avatar : this.challengeInfo.challengingAvatar;
    this.awayUsername = this.challengeInfo.forRematchIsHome ? this.userDetails.username : this.challengeInfo.challengingUsername;
  },
  methods: {
    ...mapActions('game', [
      'responseToChallenge',
    ]),
    ...mapMutations('game', [
      'setToDefaultChallengeInfo',
    ]),
    ...mapMutations('common', [
      'storeModalForChallenge',
      'unregisterModal',
    ]),
    responseToChallengeMethod(isAccepted) {
      const payload = {
        opponentUsername: this.challengeInfo.challengingUsername,
        challengeAccepted: isAccepted,
      };
      this.responseToChallenge(payload).then(() => {
        this.storeModalForChallenge(null);
        this.setToDefaultChallengeInfo();
      });
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('common', [
      'userDetails',
      'timeToAcceptChallenge',
    ]),
    ...mapState('game', [
      'challengeInfo',
    ]),
    determineWinnerCSSClass() {
      return 'modal--postgame'.concat((this.challengeInfo.forRematchIsHome && this.isGameWinnerProp) || (!this.challengeInfo.forRematchIsHome && !this.isGameWinnerProp) ? ' player1' : ' player2');
    },
    isGameWinnerProp() {
      if ((this.challengeInfo.forRematchIsHome && (this.challengeInfo.forRematchHomeScore > this.challengeInfo.forRematchAwayScore)) ||
        (!this.challengeInfo.forRematchIsHome && (this.challengeInfo.forRematchHomeScore < this.challengeInfo.forRematchAwayScore))) {
        return true;
      }
      return false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/challenge/PendingChallengedRequestRematch.vue